import { useEffect } from 'react'
import { Wrench } from 'lucide-react'
import { Button } from '@klear/ui/components/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@klear/ui/components/card'

type MaintenanceScreenProps = {
  retryIntervalMs?: number
  logoSrc?: string
}

export function MaintenanceScreen({ retryIntervalMs = 30_000, logoSrc }: MaintenanceScreenProps) {
  useEffect(() => {
    if (!retryIntervalMs) return
    const id = setInterval(() => window.location.reload(), retryIntervalMs)
    return () => clearInterval(id)
  }, [retryIntervalMs])

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background">
      {logoSrc && (
        <img
          alt="Klear"
          width="180"
          height="48"
          decoding="async"
          className="h-12 w-auto mb-8 dark:invert"
          src={logoSrc}
          style={{ color: 'transparent' }}
        />
      )}
      <Card className="w-full max-w-md shadow-xl dark:border-white/10 dark:bg-muted/40">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-muted dark:border dark:border-white/10 dark:bg-background">
            <Wrench className="h-6 w-6 text-muted-foreground" />
          </div>
          <CardTitle className="text-2xl font-bold">Down for maintenance</CardTitle>
          <CardDescription>We&apos;re making some updates and will be back soon.</CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-4">
          <Button className="w-full" onClick={() => window.location.reload()}>
            Check now
          </Button>
          {retryIntervalMs > 0 && (
            <p className="text-xs text-muted-foreground">This page checks again automatically.</p>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
